import styled from 'styled-components';
import {
    token,
    Accordion,
    StyledAccordionItem,
    StyledAccordionPanel,
    StyledAccordionHeader,
    StyledIcon,
    StyledText,
} from '@zillow/constellation';

const FAQ = styled(Accordion)`
    ${StyledAccordionItem} {
        border: none;
        border-bottom: 1px solid ${token('colors.borderLight')};
        border-radius: 0;
        margin-bottom: 0;
    }

    ${StyledAccordionHeader} {
        border: none;
        background-color: transparent;
        flex-direction: row-reverse;
        padding-left: 0;
        padding-right: 0;
        &:hover {
            ${StyledText}:first-child {
                text-decoration: none;
            }
        }
        ${StyledIcon} {
            margin-left: ${token('spacing.sm')}px;
            margin-right: 0;
            color: ${token('colors.brand')};
        }
        ${StyledText} {
            color: inherit;
        }
    }

    ${StyledAccordionPanel} {
        background-color: transparent;
        border-top: none;
        padding-left: 0;
        padding-right: 0;
    }
`;

FAQ.propTypes = {};

FAQ.defaultProps = {};

export default FAQ;
